import {
  useLinkToolbarButton,
  useLinkToolbarButtonState,
} from "@platejs/link/react";
import { Link } from "lucide-react";
import { memo } from "react";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { ToolbarButton } from "./toolbar";
import { useToolbarOverflow } from "./toolbar-overflow";

export const LinkToolbarButton = memo(function LinkToolbarButton() {
  const state = useLinkToolbarButtonState();
  const { props: buttonProps } = useLinkToolbarButton(state);
  const { isOverflow } = useToolbarOverflow();

  if (isOverflow) {
    return (
      <DropdownMenuItem onSelect={buttonProps.onClick as () => void}>
        <Link />
        Link
      </DropdownMenuItem>
    );
  }

  return (
    <ToolbarButton
      Icon={Link}
      onClick={buttonProps.onClick}
      pressed={buttonProps.pressed}
      tooltip="Link"
    />
  );
});
